import mock from './mock'

// Table
import './data/apps/chat'
/* eslint-enable import/extensions */

mock.onAny().passThrough() // forwards the matched request over network
